import script from "./applicationRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./applicationRecord.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__